import { NavigationRouteContext } from '@react-navigation/core';
import { createElement } from 'react';

import { registerChatArtifactPreviewComponent } from '@oui/app-core/src/components/ChatArtifactPreview';
import { registerChatInputArtifactHandler } from '@oui/app-core/src/components/ChatInputArtifact';

import { StressBreathingIndex } from './screens';

function BreathHoldingPreview() {
  return createElement(
    NavigationRouteContext.Provider,
    { value: { key: 'preview', name: 'StressBreathingIndex', params: { type: 'holding' } } },
    createElement(StressBreathingIndex),
  );
}

function HyperventilationPreview() {
  return createElement(
    NavigationRouteContext.Provider,
    {
      value: { key: 'preview', name: 'StressBreathingIndex', params: { type: 'hyperventilation' } },
    },
    createElement(StressBreathingIndex),
  );
}

registerChatArtifactPreviewComponent('BreathHolding', () => BreathHoldingPreview);
registerChatArtifactPreviewComponent('Hyperventilation', () => HyperventilationPreview);
registerChatInputArtifactHandler('BreathHolding', async ({ navigate, startArtifactRequest }) => {
  startArtifactRequest('BreathHolding');
  navigate('StressBreathingIndex', { type: 'holding' });
});
registerChatInputArtifactHandler('Hyperventilation', async ({ navigate, startArtifactRequest }) => {
  startArtifactRequest('Hyperventilation');
  navigate('StressBreathingIndex', { type: 'hyperventilation' });
});

export * from './screens';
export * from './components';
export * from './hooks';
export * from './types/navigation';
export * from './register';
